import styled from '@emotion/styled'

import { palette, spacing } from 'main/ui'

export const Container = styled.div`
  align-items: baseline;
  display: flex;
  flex-direction: row;
  cursor: pointer;

  > :not(:last-child) {
    margin-right: ${spacing.majorScale(1)}px;
  }
`

export const IconContainer = styled.div`
  color: ${palette.skyBlue2};
  width: 12px;
`
